import type { Retrospectives } from "./types";

export const fetchRetrospectives = async (): Promise<Retrospectives[]> => {
  try {
    const res = await fetch("/data/retrospectives.json", { cache: "no-cache" });
    return await res.json();
  } catch (err) {
    console.error("Impossible de charger retrospectives.json", err);
    return [];
  }
};